import ImportProteinPane from './ImportProteinPane';

export default ImportProteinPane;
